import { render, staticRenderFns } from "./neopark-dis-location.vue?vue&type=template&id=5fa854f0"
import script from "./neopark-dis-location.vue?vue&type=script&lang=js"
export * from "./neopark-dis-location.vue?vue&type=script&lang=js"
import style0 from "./neopark-dis-location.vue?vue&type=style&index=0&id=5fa854f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports